import _defineProperty from "@babel/runtime/helpers/defineProperty";
import AkTabs, { Tab, TabList, TabPanel } from '@atlaskit/tabs';
import { Either } from 'funfix-core';
import React, { PureComponent } from 'react';
import { APP_SPECIFIC_PASSWORD_INSTALL_MODE } from '../../../../records/InstallMode/AppSpecificPasswordInstallMode';
import { INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE } from '../../../../records/InstallMode/InstallableAppByManualUrlInstallMode';
export function foldCustomInstallMode(installMode) {
  return function foldCustomInstallModeInner(installableAppByManualUrl, appSpecificPassword) {
    switch (installMode.type) {
      case INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE:
        return installableAppByManualUrl(installMode);
      case APP_SPECIFIC_PASSWORD_INSTALL_MODE:
        return appSpecificPassword(installMode);
      default:
        // Flow compile-time validation that we've handled every custom dialog install mode
        // prettier-ignore
        installMode;
        return undefined;
    }
  };
}
class DialogCustomContainer extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onSelectTokenTab", () => {
      this.props.openAppSpecificPasswordDialog({
        name: null
      });
    });
    _defineProperty(this, "onSelectURLTab", () => {
      this.props.openManualUrlInstallDialog();
    });
    _defineProperty(this, "onChangeTab", selectedTabIndex => {
      const selectedTab = this.getTabs()[selectedTabIndex];
      if (selectedTab.installModeType === APP_SPECIFIC_PASSWORD_INSTALL_MODE) {
        this.onSelectTokenTab();
      } else if (selectedTab.installModeType === INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE) {
        this.onSelectURLTab();
      } else {
        console.error('Unknown install mode', selectedTab.installModeType);
      }
    });
    _defineProperty(this, "getTabs", () => {
      const installMode = foldCustomInstallMode(this.props.installMode)(Either.right, Either.left);
      return [{
        label: 'API tokens',
        installModeType: APP_SPECIFIC_PASSWORD_INSTALL_MODE,
        content: installMode.swap().map(() => this.props.children).toOption().orNull()
      }, {
        label: 'Installation URL',
        installModeType: INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE,
        content: installMode.map(() => this.props.children).toOption().orNull()
      }];
    });
    _defineProperty(this, "getSelectedTabIndex", () => this.getTabs().findIndex(tab => this.props.installMode.type === tab.installModeType));
  }
  render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AkTabs, {
      id: "install-custom-dialog",
      onChange: this.onChangeTab,
      selected: this.getSelectedTabIndex()
    }, /*#__PURE__*/React.createElement(TabList, null, this.getTabs().map(tab => /*#__PURE__*/React.createElement(Tab, {
      key: tab.label
    }, tab.label))), this.getTabs().map(tab => /*#__PURE__*/React.createElement(TabPanel, {
      key: tab.label
    }, tab.content))));
  }
}
export default DialogCustomContainer;